import { StowageInstructionResponseDto } from '@storage/app/api'
import { EntityStore } from '@storage/app/store/entity.store'
import { IStowageInstructionFormData } from '@storage/features/stowage-instruction/models/stowage-instruction.model'
import { YardManagementHubConnection } from '@storage/hubs/yard-management.hub-connection'
import stowageInstructionService from '@storage/services/stowage-instruction.service'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

export class StowageInstructionStore extends EntityStore<StowageInstructionResponseDto> {
  fetchedAll = false
  selectedStowageInstruction: StowageInstructionResponseDto | undefined
  constructor(yardManagementHubConnection: YardManagementHubConnection) {
    super()
    makeObservable(this, {
      fetchedAll: observable,
      selectedStowageInstruction: observable,
      setSelectedStowageInstruction: action,
      stowageInstructionNames: computed,
    })
    yardManagementHubConnection.onStowageInstructionUpserted(this.handleUpsertedEvent)
    yardManagementHubConnection.onStowageInstructionDeleted(this.handleDeletedEvent)
  }

  private readonly handleUpsertedEvent = (stowageInstruction: StowageInstructionResponseDto) => {
    this.addOrUpdate(stowageInstruction)
  }

  private handleDeletedEvent = (stowageInstructionIds: string[]) => {
    this.removeItems(stowageInstructionIds)
  }

  public get stowageInstructionNames(): string[] {
    return this.entries
      .filter(item => item.id !== this.selectedStowageInstruction?.id)
      .map(stowageInstruction => stowageInstruction.name)
  }

  public async fetchData() {
    if (this.fetchedAll) return

    const stowageInstructions = await stowageInstructionService.load()

    this.setAll(stowageInstructions)

    runInAction(() => {
      this.fetchedAll = true
    })
  }

  public async setSelectedStowageInstruction(
    stowageInstruction: StowageInstructionResponseDto | undefined,
  ) {
    this.selectedStowageInstruction = stowageInstruction
  }

  public async createStowageInstruction(formData: IStowageInstructionFormData) {
    await stowageInstructionService.create({ ...formData })
  }

  public async updateStowageInstruction(formData: IStowageInstructionFormData) {
    await stowageInstructionService.update({ ...formData })
  }

  public async deleteStowageInstructions(ids: string[]) {
    await stowageInstructionService.delete({ ids })
  }
}
